(ns net.kestec.mhda-pilgrimage.admin.applications.applications-events
  (:require
    [net.kestec.mhda-pilgrimage.db :as-alias db]
    [net.kestec.mhda-pilgrimage.route :as-alias route]
    [ajax.core :as ajax]
    [day8.re-frame.http-fx]
    [re-frame.core :as rf]
    ))

(rf/reg-event-fx
  ::load-applications
  (fn [{db :db} _]
    (println "load admin applications")
    {:http-xhrio [{:method          :get
                   :uri             (str "/api/pilgrimage/" (get-in db [::db/me :pilgrimage-id]) "/application")
                   :response-format (ajax/json-response-format {:keywords? true})
                   :on-success      [::db/set! ::admin-applications]
                   :on-failure      [::db/log-error]}]}))

(rf/reg-event-fx
  ::load-dashboard
  (fn [{db :db} _]
    (println "load admin applications statistic")
    {:http-xhrio [{:method          :get
                   :uri             (str "/api/pilgrimage/" (get-in db [::db/me :pilgrimage-id]) "/statistic")
                   :response-format (ajax/json-response-format {:keywords? true})
                   :on-success      [::db/set! ::admin-statistic]
                   :on-failure      [::db/log-error]}]}))


(rf/reg-event-db
  ::set-status-popup-application
  (fn [db [_ id]]
    (assoc db ::db/status-popup-application id)))

(rf/reg-event-db
  ::set-payment-popup-application
  (fn [db [_ id]]
    (assoc db ::db/payment-popup-application id)))


(rf/reg-event-db
  ::set-fix-popup-application
  (fn [db [_ id]]
    (assoc db ::db/fix-popup-application id)))


